<template>
  <FeatureDetailPage feature-key="multi-currency-invoicing" />
</template>
